import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DateFormat } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { LsqGroupedDataTableComponent, TotalsRowKeyPair } from '@lsq-frontend/common-ui';
import {
    CollectionCheck,
    GetCollectionChecksRequest,
    GetCollectionChecksResponse
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { LsqApiServiceListSource } from '@lsq-frontend/angular-shared/api-service';

@Component({
    selector: 'collections-grouped-table',
    templateUrl: './collections.grouped-table.component.html',
    styleUrls: ['./collections.grouped-table.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CollectionsGroupedTableComponent extends LsqGroupedDataTableComponent {
    @Input() public dataSource: LsqApiServiceListSource<
        GetCollectionChecksResponse,
        GetCollectionChecksRequest,
        CollectionCheck[]
    >;

    // Constants.
    public dateFormat = DateFormat;
    public icons = Icons;

    public setTotalsRowKeyPairs(): TotalsRowKeyPair[] {
        return [
            {
                columnKey: 'checkInvoiceAmount',
                totalKey: 'checkInvoiceAmountTotal'
            },
            {
                columnKey: 'checkPaymentAmount',
                totalKey: 'checkPaymentAmountTotal'
            },
            {
                columnKey: 'checkChargebacks',
                totalKey: 'checkChargebacksTotal'
            },
            {
                columnKey: 'checkNonFactored',
                totalKey: 'checkNonFactoredTotal'
            },
            {
                columnKey: 'checkPreviousPayments',
                totalKey: 'checkPreviousPaymentsTotal'
            },
            {
                columnKey: 'checkInvoiceBalance',
                totalKey: 'checkInvoiceBalanceTotal'
            },
            {
                columnKey: 'checkCollectionFees',
                totalKey: 'checkCollectionFeesTotal'
            }
        ];
    }
}
